import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from '../locales/en.json';
import de from '../locales/de.json';
import {mapDetectedLocaleToI18nLocale} from '../utils/localeUtils';

const resources = {
    'en-US': {
        translation: en
    },
    'de-DE': {
        translation: de
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en-US',
        debug: import.meta.env.DEV,

        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            lookupLocalStorage: 'i18nextLng',
            convertDetectedLanguage: (lng) => {
                return mapDetectedLocaleToI18nLocale(lng);
            }
        },

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
